import React from "react";
import "./AnimatedFeedbackPopup.css";

export default function AnimatedFeedbackPopup({ open, type = "success", title, subtitle }) {
  if (!open) return null;

  const isSuccess = type === "success";
  const popupClass = isSuccess ? "feedback-popup feedback-popup--success" : "feedback-popup feedback-popup--error";

  return (
    <div className="feedback-popup-backdrop" role="presentation">
      <div className={popupClass} role="status" aria-live="polite">
        <div className="feedback-popup__ring" />
        {/* <div className="feedback-popup__icon">{isSuccess ? "✓" : "!"}</div> */}
        <div className="feedback-popup__title">{title || (isSuccess ? "Awesome!" : "Try Again")}</div>
        {subtitle ? <div className="feedback-popup__subtitle">{subtitle}</div> : null}
      </div>
    </div>
  );
}
